// cart-patch.js
;(function(){
  function onCartPage(){
    return document.body.classList.contains('template-cart') || !!document.querySelector('.section--cart-page');
  }

  function isWriteUrl(u){
    return u && (u.includes('/cart/add.js') || u.includes('/cart/update.js') || u.includes('/cart/change.js') || u.includes('/cart/clear.js'));
  }

  function pokeBooster() {
    try {
      localStorage.setItem('bstr:cart:update', String(Date.now()));
      window.dispatchEvent(new StorageEvent('storage', {
        key: 'bstr:cart:update',
        newValue: String(Date.now()),
        oldValue: null,
        storageArea: localStorage,
        url: location.href
      }));
    } catch(e){}
  }

  // wrap fetch()
  if (window.fetch) {
    const _f = window.fetch;
    window.fetch = function(...args){
      return _f.apply(this,args).then(res=>{
        const u = (res.url||'');
        // Only poke on write AND not on the cart page
        if (!onCartPage() && isWriteUrl(u)) pokeBooster();
        return res;
      });
    };
  }

  // wrap XHR
  if (window.XMLHttpRequest) {
    const open = XMLHttpRequest.prototype.open;
    const send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(m,u,...r){
      this._url = u; 
      this._method = m;
      return open.call(this,m,u,...r);
    };
    XMLHttpRequest.prototype.send = function(b){
      this.addEventListener('load',()=>{
        if (!onCartPage() && isWriteUrl(this._url)) pokeBooster();
      });
      return send.call(this,b);
    };
  }
})();
